import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    flexGrow: 1,
    // minHeight: theme.spacing(50),
    // maxWidth: `calc(100% - ${theme.spacing(6) * 2}px)`,
    padding: theme.spacing(6),
    color: theme.palette.text.primary,
    display: 'flex',
    flexDirection: 'column',

    '& .error-message': {
      '&-content': {
        width: '100%',
        maxWidth: theme.spacing(120),
        margin: 'auto',
      },
      '&-icon': {
        color: theme.palette.custom.feedback.warning,
      },
      '&-title': {
        width: '100%',
        marginBottom: theme.spacing(2),
      },
      '&-description': {
        width: '100%',
        marginBottom: theme.spacing(6),
      },
      '&-button': {
        marginRight: theme.spacing(2),
      },
    },

    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(3),
      '& .error-message': {
        '&-icon': {
          fontSize: theme.spacing(8),
        },
      },
    },

    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.custom.background.app,
      '& .error-message': {
        '&-icon': {
          fontSize: theme.spacing(6),
        },
        '&-title': {
          fontSize: theme.typography.h6.fontSize,
        },
        '&-description': {
          fontSize: theme.typography.body2.fontSize,
        },
      },
    },
  },
}));

export default styles;
